<template>

  <div class="container">
     <b-modal
      ref="bill-warranty-modal"
      hide-footer
      :titleHtml="modalTitle"
      size="xl"
      > <v-form ref="form"
        > <b-row class="mb-4"
          > <b-col md="4"
            > <b-input
              size="sm"
              placeholder="Tìm kiếm"
              v-model="searchText"
              append-icon="search"
              single-line
              hide-details
              v-on:keyup.enter="onFilter()"
            ></b-input
            > </b-col
          > <b-col md="1"
            > <b-button
              style="fontweight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            > </b-col
          > </b-row
        > <b-table
          :items="listItem"
          :fields="fields"
          :busy="onLoading"
          bordered
          hover
          show-empty
          class="product-table"
          > <template #empty="scope"
            >
            <h5 class="text-center">Không có gói bảo hành nào được gợi ý</h5>
             </template
          > <template v-slot:head(selected)
            > <span
              > <b-form-checkbox
                v-model="isCheckAll"
                size="lg"
                @change="clickAll"
              ></b-form-checkbox
              > </span
            > </template
          > <!-- check bõ --> <template v-slot:cell(selected)="row"
            >
            <div class="d-flex justify-content-center">
               <b-form-checkbox
                size="lg"
                v-model="row.item.checked"
                @change="clickIndex()"
              ></b-form-checkbox
              >
            </div>
             </template
          > <template v-slot:cell(id)="row"
            >
            <div>
               <span
                v-text="row.item.id"
                class="d-flex justify-content-center"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(productName)="row"
            >
            <div style="display: flex; gap: 8px; align-items: center">
               <ProductImage :src="row.item.productImageUrl" />
              <div>
                 <span
                  v-text="row.item.barCode"
                  style="font-size: 12px"
                  v-show="row.item.barCode"
                ></span
                ><br /> <span
                  v-text="row.item.productCode"
                  style="font-size: 13px"
                  v-show="row.item.productCode"
                ></span
                ><br /> <span
                  v-text="row.item.productName"
                  style="white-space: normal; color: #3699ff; font-size: 13px"
                ></span
                >
              </div>

            </div>
             </template
          > <template v-slot:cell(warrantyProgramCode)="row"
            >
            <div>
               <span
                v-text="row.item.warrantyProgramDescription"
                class="d-flex"
              ></span
              > <span
                v-if="row.item.warrantyProgramCode"
                class="badge badge-secondary badge-pill mt-1 d-inline-block"
                >{{ row.item.warrantyProgramCode }}</span
              >
            </div>
             </template
          > </b-table
        > <b-button
          style="fontweight: 600; width: 100px"
          variant="primary"
          size="sm"
          @click="submit"
          >Áp dụng</b-button
        > <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          @click="hideModal"
          > Hủy </b-button
        > </v-form
      > </b-modal
    >
  </div>

</template>

<style scoped>
  .product-table /deep/ th {
  text-align: center;
  font-weight: 600;
  color: '#181c32';
}
</style>

<script>
  import { convertPrice, xoa_dau } from '@/utils/common'
  import { BILL_ITEM_TYPE } from '@/utils/enum'
  import { v4 } from 'uuid'
  import { cloneDeep } from 'lodash'
  import ApiService from '@/core/services/api.service'
  import ProductImage from '@/view/components/products/ProductImage.vue'

  export default {
    props: ['billItemId', 'productName', 'storeId', 'productId'],
    data() {
      return {
        modalTitle: '',
        searchText: '',
        listItem: [],
        listItemDraff: [],
        fields: [
          {
            key: 'selected',
            label: '',
            sortable: false,
          },
          {
            key: 'productName',
            label: 'Sản phẩm',
            sortable: false,
          },
          {
            key: 'sellingPrice',
            label: 'Giá bán',
            sortable: false,
            tdClass: 'text-right',
            formatter: (value, key, item) => {
              const finalPrice = Number(item.finalSellingPrice ?? value ?? 0)
              return convertPrice(finalPrice)
            },
          },
          { key: 'warrantyProgramCode', label: 'Mô tả GBH' },
        ],
        isCheckAll: false,
        onLoading: false,
      }
    },
    components: {
      ProductImage,
    },
    methods: {
      convertPrice,
      showModal: function () {
        this.searchText = ''
        this.fetchProductWarranty()
        this.listItemDraff = cloneDeep(this.listItem)
        this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Thêm gói bảo hành cho sản phẩm: <a class='text-primary'>#${this.productName}</a></span>
              </div>`
        this.$refs['bill-warranty-modal'].show()
      },
      hideModal: function () {
        this.$refs['bill-warranty-modal'].hide()
      },
      clickAll() {
        this.listItem.forEach((item) => {
          item.checked = this.isCheckAll
        })
      },

      clickIndex() {
        this.isCheckAll = this.listItem.every((item) => item.checked)
      },
      onFilter() {
        const textSearch = this.searchText ? this.searchText.trim() : ''
        this.listItem = this.listItemDraff
          .filter((item) => {
            const nameNoneSign = xoa_dau(item.name)
            return (
              nameNoneSign.toLowerCase().indexOf(textSearch.toLowerCase()) > -1 ||
              item.name.toLowerCase().indexOf(textSearch.toLowerCase()) > -1
            )
          })
          .slice(0, 10)
      },
      submit() {
        const listResult = this.listItem.filter((item) => item.checked)
        this.$emit('addWarranty', listResult)
        this.hideModal()
      },
      fetchProductWarranty() {
        this.onLoading = true
        ApiService.query(`v1/product-promotion/warranty`, {
          params: {
            productId: this.productId,
          },
        })
          .then(({ data }) => {
            const responseData = data.data || []
            this.listItem = responseData.map((data) => {
              const finalPrice = Number(data.finalSellingPrice ?? data.sellingPrice ?? 0)
              return {
                id: v4(),
                checked: false,
                itemType: BILL_ITEM_TYPE.PRODUCT_PROMTION,
                belongBillDetailId: this.billItemId,
                ...data,
                sellingPrice: finalPrice,
              }
            })
            this.onLoading = false
          })
          .catch(() => {
            this.onLoading = false
          })
      },
    },
  }
</script>

